module.exports = __webpack_public_path__ + "img/infraserv-logo.6c0ce79d.png";